import React from "react";
import { Table } from 'react-bootstrap';
import { Button } from 'antd';
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var CustomerTable = function CustomerTable(_ref) {
  var customers = _ref.customers,
    table = _ref.table,
    _ref$sheetDisplayHand = _ref.sheetDisplayHandler,
    sheetDisplayHandler = _ref$sheetDisplayHand === void 0 ? null : _ref$sheetDisplayHand;
  var handleDisplay = function handleDisplay(c) {
    sheetDisplayHandler(c);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(ReactHTMLTableToExcel, {
      id: "test-table-xls-button",
      className: "download-table-xls-button",
      table: table,
      filename: "candidats",
      sheet: "tablexls",
      buttonText: "Export excel"
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Table, {
      id: table,
      responsive: "md",
      children: [/*#__PURE__*/_jsx("thead", {
        children: /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx("th", {
            children: "Date"
          }), /*#__PURE__*/_jsx("th", {
            children: "RNC"
          }), /*#__PURE__*/_jsx("th", {
            children: "Pr\xE9nom"
          }), /*#__PURE__*/_jsx("th", {
            children: "Nom"
          }), /*#__PURE__*/_jsx("th", {
            children: "T\xE9l\xE9phone"
          }), /*#__PURE__*/_jsx("th", {
            children: "Agent caisse"
          }), /*#__PURE__*/_jsx("th", {
            children: "M.paiement"
          }), /*#__PURE__*/_jsx("th", {})]
        })
      }), /*#__PURE__*/_jsx("tbody", {
        children: customers.map(function (c) {
          return /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("td", {
              children: new Date(c.created_at).toLocaleDateString('Fr', {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
              })
            }), /*#__PURE__*/_jsx("td", {
              children: c.rnc
            }), /*#__PURE__*/_jsx("td", {
              children: c.firstname
            }), /*#__PURE__*/_jsx("td", {
              children: c.lastname
            }), /*#__PURE__*/_jsx("td", {
              children: c.mobile
            }), /*#__PURE__*/_jsx("td", {
              children: c.user.firstname + ' ' + c.user.lastname
            }), /*#__PURE__*/_jsx("td", {
              children: c.paymentmethod.label
            }), /*#__PURE__*/_jsx("td", {
              children: /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: function onClick() {
                  handleDisplay(c);
                },
                children: "Voir le dossier"
              })
            })]
          }, c.id);
        })
      })]
    })]
  });
};
export default CustomerTable;